module.exports = __webpack_public_path__ + "img/phone.dc3919d3.svg";